var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.271484 3.81252C0.271484 1.70692 1.97841 0 4.084 0H20.6049C24.8161 0 28.23 3.41385 28.23 7.62504V24.146C28.23 26.2516 26.523 27.9585 24.4174 27.9585H4.084C1.9784 27.9585 0.271484 26.2516 0.271484 24.146V3.81252Z",
    fill: "#108DA0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4595 15.6475L17.9185 12.6577H15.0496V10.7175C15.0496 9.89975 15.4502 9.1021 16.7352 9.1021H18.0393V6.55685C18.0393 6.55685 16.856 6.35498 15.7243 6.35498C13.3618 6.35498 11.8177 7.78714 11.8177 10.3794V12.6582H9.19135V15.648H11.8177V22.8759H15.0496V15.648L17.4595 15.6475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5209,
    height: 16.5209,
    fill: "white",
    transform: "translate(5.35486 6.354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c1e3c6d77e9df39fc975d2bd6611ead2.svg";
export { ForwardRef as ReactComponent };